import * as serializr from 'serializr';
import StudioStore from '../stores/StudioStore';
export default class LocalStorage {
    /**
     * Updates the given store with the stored state in the localStorage
     * @param store StudioStore
     */
    load(store) {
        // TODO handle localStorage modifications with a versioning prop
        return new Promise((resolve, reject) => {
            const rawState = localStorage.getItem(StudioStore.KEY);
            if (rawState) {
                try {
                    serializr.update(StudioStore, store, JSON.parse(rawState));
                    resolve();
                }
                catch (err) {
                    reject(new Error('Unable to load saved state from LocalStorage.\nCaused by:\n' + err.stack));
                }
            }
            else {
                resolve();
            }
        });
    }
    /**
     * Save store state to localStorage
     * @param store StudioStore
     */
    save(store) {
        localStorage.setItem(StudioStore.KEY, JSON.stringify(serializr.serialize(store)));
        return Promise.resolve();
    }
    /**
     * Erases all storage content.
     */
    clear() {
        localStorage.clear();
        return Promise.resolve();
    }
}
